<template>
  <b-modal
    @close="closeDecisionModal()"
    hide-footer
    v-model="vModel"
    size="xl"
    :title="'Décision - Permission de voirie - Accès/Clôture'"
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form
        @submit.prevent="handleSubmit(decision)"
        v-if="request && request.cerfa1402301"
      >
        <b-row>
          <b-col lg="5" md="3" sm="12" cols="12">
            <label class="control-label"
              >Décision <span class="red">*</span> :</label
            >
          </b-col>
          <b-col lg="4" md="9" sm="12" cols="12">
            <ValidationProvider
              mode="lazy"
              v-slot="{ errors }"
              rules="required"
              name="décision"
            >
              <b-form-radio-group
                v-model="request.cerfa1402301.isFavorable"
                :options="optionsDecision"
              ></b-form-radio-group>
              <div class="error">{{ errors[0] }}</div>
            </ValidationProvider>
          </b-col>
        </b-row>
        <div v-if="request.cerfa1402301.isFavorable == true">
          <b-row>
            <b-col lg="5" md="3" sm="12" cols="12">
              <label class="control-label">Annexe 1 (PDF):</label>
            </b-col>
            <b-col lg="6" md="9" sm="12" cols="12">
              <b-form-file
                browse-text="Ouvrir"
                v-model="annexe1.file"
                placeholder="Choisissez un fichier ou glissez le ici..."
                drop-placeholder="Glissez un Fichier ici..."
                accept="application/pdf"
              ></b-form-file>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="5" md="3" sm="12" cols="12">
              <label class="control-label">Annexe 2 (PDF):</label>
            </b-col>
            <b-col lg="6" md="9" sm="12" cols="12">
              <b-form-file
                browse-text="Ouvrir"
                v-model="annexe2.file"
                placeholder="Choisissez un fichier ou glissez le ici..."
                drop-placeholder="Glissez un Fichier ici..."
                accept="application/pdf"
              ></b-form-file>
            </b-col>
          </b-row>

          <!-- dropdown adresse principale -->
          <b-card no-body class="my-2">
            <b-card-header class="p-0">
              <b-button block v-b-toggle.adresse-principale
                >Adresse Principale</b-button
              >
            </b-card-header>
            <b-collapse
              id="adresse-principale"
              visible
              accordion="principale"
              role="tabpanel"
            >
              <b-card-body>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">État des lieux :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessEdl"
                      :options="optionsEDL"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Ouverture / Portail :</label>
                  </b-col>
                  <b-col lg="6" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessPortailOpen"
                      :options="optionsOuverturePortail"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Stationnement :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessStationnement"
                      :options="optionsOuiNonStationnement"
                    ></b-form-radio-group>
                  </b-col>
                </b-row> -->
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Retournement :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessRetournement"
                      :options="optionsOuiNonRetournement"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Etat du domaine public :</label
                    >
                  </b-col>
                  <b-col lg="7" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessRemiseEtatDp"
                      :options="optionsRemiseEtatDp"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Eaux pluviales :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessEauxPluviales"
                      :options="optionsOuiNonEP"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Fossé :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionAccessFosse"
                      :options="optionsOuiNonFosse"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row v-if="request.cerfa1402301.decisionAccessFosse == true">
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Diamètre Ø en mm :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-input
                      v-model="request.cerfa1402301.decisionAccessFosseDiametre"
                      type="number"
                      step="0.5"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>

          <!-- TOUTES LES AUTRES ADRESSES -->
          <b-card
            no-body
            class="my-2"
            v-for="(address, index) in request.adresses"
            :key="index"
          >
            <b-card-header class="p-0">
              <b-button block v-b-toggle="'adresse-secondaire-' + index"
                >Adresse secondaire ({{ index + 1 }}) :
                <font-awesome-icon class="mr-1" icon="map-marker-alt" />{{
                  address.addressNum
                }}
                {{ address.addressType }} {{ address.addressName }},
                {{ address.addressPostalCode }}
                {{ address.addressCity }}</b-button
              >
            </b-card-header>
            <b-collapse
              :id="'adresse-secondaire-' + index"
              accordion="secondaire"
              role="tabpanel"
            >
              <b-card-body>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">État des lieux :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionAccessEdl"
                      :options="optionsEDL"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Ouverture / Portail :</label>
                  </b-col>
                  <b-col lg="6" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionAccessPortailOpen"
                      :options="optionsOuverturePortail"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Stationnement :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="
                        address.prescriptions.decisionAccessStationnement
                      "
                      :options="optionsOuiNonStationnement"
                    ></b-form-radio-group>
                  </b-col>
                </b-row> -->
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Retournement :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionAccessRetournement"
                      :options="optionsOuiNonRetournement"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Etat du domaine public :</label
                    >
                  </b-col>
                  <b-col lg="7" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionAccessRemiseEtatDp"
                      :options="optionsRemiseEtatDp"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Eaux pluviales :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="
                        address.prescriptions.decisionAccessEauxPluviales
                      "
                      :options="optionsOuiNonEP"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Fossé :</label>
                  </b-col>
                  <b-col lg="5" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionAccessFosse"
                      :options="optionsOuiNonFosse"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row v-if="address.prescriptions.decisionAccessFosse == true">
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Diamètre Ø en mm :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-input
                      v-model="
                        address.prescriptions.decisionAccessFosseDiametre
                      "
                      type="number"
                      step="0.5"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <div v-if="request.cerfa1402301.isFavorable == false">
          <b-row>
            <b-col lg="5" md="3" sm="12" cols="12">
              <label class="control-label">Motifs liés à la sécurité :</label>
            </b-col>
            <b-col lg="5" md="9" sm="12" cols="12">
              <b-form-checkbox-group
                v-model="refus_motifs_acces_selected"
                :options="optionsMotifsRefusAcces"
              ></b-form-checkbox-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3" md="3" sm="12" cols="12">
              <label class="control-label">Motifs :</label>
            </b-col>
            <b-col lg="9" md="9" sm="12" cols="12">
              <b-form-textarea
                v-model="request.cerfa1402301.commentDecision"
                id="commentDecision"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </div>
        <div v-for="(mail, index) in request.mailArreteSignes" :key="mail.id">
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <label
                ><b>{{ index + 1 }}</b
                >, Mail :</label
              >
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required|email"
                name="email"
              >
                <b-form-input v-model="mail.mail"></b-form-input>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
            <b-col lg="4" md="6" sm="12" cols="12">
              <label>Dénomination:</label>
              <b-form-input v-model="mail.name"></b-form-input>
            </b-col>
            <b-col lg="1" md="6" sm="12" cols="12">
              <b-button
                class="center-icone"
                size="sm"
                variant="danger"
                style="margin-top: 40px"
                @click="removeDestinataire(index)"
                ><font-awesome-icon icon="times"></font-awesome-icon
              ></b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col lg="3" md="6" sm="12" cols="12" v-if="showBtnArreteEdition">
            <b-button
              class="mr-5 mb-2"
              variant="primary"
              size="sm"
              @click="doArrete()"
              :disabled="showBtnGen"
              >Générer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button
              class="mr-5 mb-2"
              variant="primary"
              size="sm"
              @click="editArrete()"
              :disabled="showBtnArreteEdition"
              >Éditer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button
              class="mr-5 mb-2"
              variant="danger"
              size="sm"
              @click="removeCourrier()"
              :disabled="showBtnArreteEdition"
              >Supprimer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button
              type="submit"
              :disabled="showBtnArreteEdition"
              class="mr-5 mb-2"
              variant="success"
              size="sm"
              >Signature
            </b-button>
          </b-col>
          <b-col lg="3" md="6" sm="12" cols="12">
            <b-button variant="white" size="sm" @click="closeDecisionModal()"
              >Fermer et sauvegarder
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import router from "../../router/index.js";
import Vuex from "vuex";

export default {
  props: ["value"],
  data() {
    return {
      optionsEDL: [
        { text: "Nouvel accès", value: "Nouvel accès" },
        { text: "Accès existant", value: "Accès existant" },
      ],
      refus_motifs_acces_selected: [],
      optionsOuverturePortail: [
        { text: "limite de propriété", value: "limite de propriété" },
        { text: "en retrait de 5 mètres", value: "en retrait de 5 mètres" },
      ],
      optionsOuiNonStationnement: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      optionsOuiNonRetournement: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],

      optionsRemiseEtatDp: [
        { text: "Pérenniser", value: "Pérenniser" },
        {
          text: "Aménagement existant : Remise en état",
          value: "Aménagement existant : Remise en état",
        },
      ],
      optionsOuiNonEP: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      optionsOuiNonFosse: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      optionsMotifsRefusAcces: [
        {
          text: "multiplication des accès",
          value: "multiplication des accès",
        },
        {
          text: "visibilité",
          value: "visibilité",
        },
      ],
      optionsDecision: [
        { text: "Favorable", value: true },
        { text: "Défavorable", value: false },
      ],
      annexe1: {
        file: null,
        typeDocument: {},
      },
      annexe2: {
        file: null,
        typeDocument: {},
      },
    };
  },
  methods: {
    addDestinataire() {
      let newDestinataire = {
        id: null,
        email: null,
      };
      this.request.mailArreteSignes.push(newDestinataire);
    },

    removeDestinataire(index) {
      this.request.mailArreteSignes.splice(index, 1);
    },
    ...Vuex.mapActions("Cerfa", ["setCerfa14023", "updateCerfa14023"]),
    ...Vuex.mapActions("Document", ["sendDocument"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "addReception",
      "sendToClicmap",
    ]),

    async doArrete() {
      //this.request.cerfa1402301.isFavorable = null;

      this.request.cerfa1402301.decisionAccessMotifsRefus = this.refus_motifs_acces_selected.join();
      this.request.cerfa1402301.instructeurId = this.userConnected.id;
      await this.updateCerfa14023(this.request.cerfa1402301);

      //ATTENTION FIX URGENCE pas de tableau pour OnlyOffice !
      this.request.stateId = 999;
      this.request.sendToSign = false;

      //Token qui peut servier pour sécuriser la route pour édition de l'arrêté
      // this.request.tokenUser = window.$cookies.get("token-sudthd");

      //noMail permet de mettre à jour la request sans envoyer de mail, quand la request conserve son stateId 3
      this.request.noMail = true;
      await this.updateDossier(this.request);

      let dataToSend = {};

      Object.flatten = function(data) {
        var result = {};
        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            for (var i = 0, l = cur.length; i < l; i++)
              recurse(cur[i], prop + "[" + i + "]");
            if (l == 0) result[prop] = null;
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "_" + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

      Object.toSlaveData = function(data) {
        var result = {};
        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            let slaveData = {};
            slaveData[prop] = [];
            for (var i = 0, l = cur.length; i < l; i++) {
              slaveData[prop][i] = Object.toSlaveData(cur[i]);
            }
            result["slaveData"] = slaveData;
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "_" + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

      dataToSend = Object.flatten(this.request);
      dataToSend.slaveData = {};
      let adresses = [];
      this.request.adresses.forEach((element) => {
        adresses.push(Object.toSlaveData(element));
      });
      dataToSend.slaveData.adresses = adresses;
      //ATTENTION FIX URGENCE pas de tableau pour OnlyOffice !
      //Les données nécessaires sont récupérées dans le back

      delete dataToSend.adresses;
      delete dataToSend.petitioner_beneficiaryRequests;
      delete dataToSend.ticketOffices;
      delete dataToSend.mailArreteSignes;
      delete dataToSend.beneficiary_petitionerRequests;
      delete dataToSend.documents;
      delete dataToSend.individualAlignmentRequest_rues;

      await this.startMerge(dataToSend);
      await this.getDossier(this.request.id);
    },
    editArrete() {
      let docArreteid = null;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            docArreteid = element.id;
          }
        });
      }
      if (docArreteid !== null) {
        let url = window.urlapi + 'onlyoffice/' + docArreteid;

        fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + window.$cookies.get("token-sudthd")
            }
          })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error(`Erreur ${response.status} : ${text}`);
            }
            return response.text();
          })
          .then((html) => {
            const newWindow = window.open();
            if (newWindow) {
              newWindow.document.open();
              newWindow.document.write(html);
              newWindow.document.close();
            } else {
              Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
            }
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du courrier :", error);
            Vue.prototype.$awn.alert("Erreur lors de l'ouverture du courrier : " + error.message, {
              position: "bottom-right",
              timeout: 5000,
            });
          });
      } else {
        alert("Aucun arrêté de généré pour cette demande");
      }
    },
    async removeCourrier() {
      let doc = false;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            doc = element;
          }
        });
      }
      // console.log(doc);
      await this.removeDocument(doc.id);
      await this.getDossier(this.request.id);
      return;
      // this.$emit("removeDocument", doc);
    },
    async decision() {
      //Condition pour création d'une annexe
      if (this.annexe1.file == null && this.annexe2.file == null) {
        this.request.doAnnexe = false;
      }
      if (this.annexe1.file != null) {
        if (this.annexe1.file.type != "application/pdf") {
          alert("L'annexe 1 n'est pas un type : \"application/pdf\"");
          return false;
        } else {
          this.annexe1.file.requestId = this.request.id;
          this.annexe1.file.typeDocumentId = 97;
          this.annexe1.file.stdUserId = this.userConnected.id;
          this.request.doAnnexe = true;
          await this.sendDocument(this.annexe1.file);
        }
      }
      if (this.annexe2.file != null) {
        if (this.annexe2.file.type != "application/pdf") {
          alert("L'annexe 2 n'est pas un type : \"application/pdf\"");
          return false;
        } else {
          this.annexe2.file.requestId = this.request.id;
          this.annexe2.file.typeDocumentId = 97;
          this.annexe2.file.stdUserId = this.userConnected.id;
          this.request.doAnnexe = true;
          await this.sendDocument(this.annexe2.file);
        }
      }
      this.request.cerfa1402301.decisionAccessMotifsRefus = this.refus_motifs_acces_selected.join();
      this.request.cerfa1402301.instructeurId = this.userConnected.id;
      await this.updateCerfa14023(this.request.cerfa1402301);

      //MAJ dossier
      this.request.state.id = 3;
      this.request.stateId = 3;
      this.request.sendToSign = true;
      this.request.instructeurId = this.userConnected.id;
      this.request.noMail = true;

      await this.updateDossier(this.request);
      this.vModel = false;

      this.sendToClicmap(this.request.id);
    },

    async closeDecisionModal() {
      this.annexe1 = {
        file: null,
        typeDocument: {},
      };
      this.annexe2 = {
        file: null,
        typeDocument: {},
      };
      this.arrete = {
        file: null,
        typeDocument: {},
      };
      this.request.sendToSign = false;
      this.request.cerfa1402301.decisionAccessMotifsRefus = this.refus_motifs_acces_selected.join();
      this.request.cerfa1402301.instructeurId = this.userConnected.id;
      await this.updateCerfa14023(this.request.cerfa1402301);

      //noMail permet de mettre à jour la request sans envoyer de mail, quand la request conserve son stateId 3
      this.request.noMail = true;
      await this.updateDossier(this.request);

      this.vModel = false;
    },
    ...Vuex.mapActions("Document", ["removeDocument"]),
  },
  mounted() {
    if (this.request.cerfa1402301.decisionAccessMotifsRefus !== null) {
      this.refus_motifs_acces_selected = this.request.cerfa1402301.decisionAccessMotifsRefus.split(
        ","
      );
    }
  },
  computed: {
    showBtnGen() {
      let disabled = true;
      if (
        this.request.cerfa1402301 &&
        this.request.cerfa1402301.isFavorable !== null
      ) {
        disabled = false;
      }
      return disabled;
    },
    showBtnArreteEdition() {
      //Si dans la liste des docs tu as un arrêté avec type 93 ? alors on récup sont ID pour construire urlOpenDoc
      let disabled = true;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            disabled = false;
          }
        });
      }
      return disabled;
    },
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    vModel: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },
    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
};
</script>
